require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./plane-auf-abwegen.json") })
        }
      }, "path---plane-auf-abwegen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---plane-auf-abwegen!./.cache/json/plane-auf-abwegen.json
// module id = 430
// module chunks = 231608221292675